import axios from 'axios'
import router from '@/router'
import AuthMiddleware from '@/middlewares/authMiddleware'
import { fetchRemoteRevision } from '@/api/preHttpClient'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE,
})
// const httpClient = axios.create({ baseURL: 'http://localhost:8080/api/' })

/*
 * APIリクエスト前処理
 */
httpClient.interceptors.request.use(
  async config => {
    /* 本番環境の場合、remoteのバージョンとlocalのバージョンをチェック */
    if (process.env.NODE_ENV === 'production') {
      const remoteRevision = await fetchRemoteRevision()
      const localRevision = window.localRevision
      if (remoteRevision !== localRevision) window.location.reload(true)
    }

    /* auth token をheaderにset */
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const isBetaVersion = localStorage.getItem('beta')
    if (isBetaVersion && isBetaVersion === 'true') {
      config.headers.common['Api-Version'] = 'beta'
    }

    return config
  },
  error => {
    return Promise.reject(error)
  },
)

/*
 * APIレスポンスを受け取った時、
 * サーバからstatus code 401が返ってきた場合は、
 * 認証期限が切れているので、
 * 強制的にログインページに移動させる
 */
httpClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const status = error.response.status
    // eslint-disable-next-line
    let message
    if (status === 401) {
      // 認証エラー
      // 強制ログアウトする
      AuthMiddleware.logout()
      message = '認証エラーです。再度ログインしてください。'
      router.push('/').catch(() => {})
      return Promise.reject(new Error(message))
    } else if (status === 403) {
      // 権限エラー
      message = '権限がありません。システム管理者へ連絡してください。'
      return Promise.reject(new Error(message))
    } else {
      return Promise.reject(error)
    }
  },
)

export default httpClient
